import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Alert, Input } from '@sainsburys-tech/bolt';
import { LocationIcon } from '@sainsburys-tech/bolt-icons';
import * as Styled from './Search.styles';
var PROP_TYPES = {
  searchTerm: PropTypes.string,
  onSearch: PropTypes.func,
  error: PropTypes.string,
  enableGeoLocation: PropTypes.bool,
  label: PropTypes.string
};
var DEFAULT_PROPS = {
  enableGeoLocation: false,
  searchTerm: ''
}; // new mandatory AO parameter. It will be prefixed with the value of the "code" property of the nested "analytics" object of the "config" object

var aoSaveParam = '-ss:ss';

var Search = function Search(_ref) {
  var onSearch = _ref.onSearch,
      searchTerm = _ref.searchTerm,
      error = _ref.error,
      enableGeoLocation = _ref.enableGeoLocation,
      label = _ref.label;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      geolocationError = _useState4[0],
      setGeolocationError = _useState4[1];

  var _useState5 = useState(searchTerm),
      _useState6 = _slicedToArray(_useState5, 2),
      inputSearchTerm = _useState6[0],
      setInputSearchTerm = _useState6[1];

  useEffect(function () {
    setInputSearchTerm(searchTerm);
  }, [searchTerm]);

  var onSearchByGeolocation = function onSearchByGeolocation(event) {
    if (event !== null) event.preventDefault();
    setLoading(true);
    setGeolocationError(false);

    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        var _position$coords = position.coords,
            latitude = _position$coords.latitude,
            longitude = _position$coords.longitude;
        onSearch("".concat(latitude, ",").concat(longitude), aoSaveParam, false);
        setLoading(false);
      }, function () {
        setLoading(false);
        setGeolocationError(true);
      });
    } else {
      setLoading(false);
      setGeolocationError(true);
    }
  };

  var updateSearchTerm = function updateSearchTerm(evt) {
    if (evt !== null) evt.preventDefault();
    setInputSearchTerm(evt.target.value);
  };

  var onSubmitSearch = function onSubmitSearch(submitSearchTerm, evt) {
    if (evt !== null) evt.preventDefault();
    setGeolocationError(false);
    onSearch(submitSearchTerm, true, true, aoSaveParam);
  };

  return /*#__PURE__*/React.createElement(Styled.SearchContainer, null, /*#__PURE__*/React.createElement(React.Fragment, null, (error || geolocationError) && /*#__PURE__*/React.createElement(Alert, {
    kind: "error",
    isCloseable: false,
    "data-test": "component-ss-alert"
  }, geolocationError ? "Sorry, we're unable to determine your location. Please try searching by town or postcode." : error), /*#__PURE__*/React.createElement(Styled.SearchWrapper, {
    onSubmit: function onSubmit(evt) {
      return onSubmitSearch(inputSearchTerm, evt);
    }
  }, /*#__PURE__*/React.createElement(Input, {
    submitElement: "Find",
    value: inputSearchTerm,
    placeholder: "My town or postcode is...",
    onChange: function onChange(evt) {
      return updateSearchTerm(evt);
    },
    "data-test": "store-selector-search-bar",
    buttonOptions: {
      show: true,
      text: 'Find',
      type: 'submit'
    },
    label: label
  }), enableGeoLocation && /*#__PURE__*/React.createElement(Styled.LocationButton, {
    iconOnly: true,
    kind: "secondary",
    isLoading: loading,
    onClick: function onClick(evt) {
      return onSearchByGeolocation(evt);
    },
    "data-test": "location-button"
  }, /*#__PURE__*/React.createElement(LocationIcon, {
    width: "30",
    height: "30"
  })))));
};

Search.propTypes = PROP_TYPES;
Search.defaultProps = DEFAULT_PROPS;
export default Search;